import { CSSProperties, FormHTMLAttributes, PropsWithChildren } from "react";

export type UIFormProps = PropsWithChildren<FormHTMLAttributes<HTMLFormElement>> & {
  sx?: Record<string, unknown>;
};

export const UIForm = ({ sx, style, children, ...props }: UIFormProps) => {
  const sxStyle = (sx ?? {}) as CSSProperties;

  return (
    <form style={{ ...sxStyle, ...style }} {...props}>
      {children}
    </form>
  );
};
